
import { Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Options({})
export default class NoImageAvailable extends Vue {
  @Prop() size?: number = 24;
}
